import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import RootContext from '../../../util/root.context';
import { clearAllCookies } from '../../hooks/useCookie';
import { clearLocalStorage } from '../../hooks/useLocalStorage';
import EirActionModal from '../eir-action-modal/EirActionModal';
import { displayCart } from '../eir-cart/cart.util';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const EirLogOutModal = ({ confirmLogOut }) => {
  const { dispatch } = useContext(RootContext);
  const router = useRouter();

  const handleOk = () => {
    confirmLogOut.disable();
  };
  const handleLogOut = () => {
    window.localStorage.clear();
    clearLocalStorage();
    clearAllCookies();
    confirmLogOut.disable();
    dispatch({ type: 'SET_CART', payload: null });
    displayCart({
      dispatch,
      showCart: false,
    });
    dispatch({ type: 'ENABLE_LOGOUT', payload: false });
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}`);
  };

  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'log_out_modal',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={confirmLogOut.value}
      handleClose={confirmLogOut.disable}
      title={cmsCollectionData?.attributes?.title}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `}
      cta={[
        {
          // text: 'Logout',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Logout',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => handleLogOut(),
        },

        {
          // text: 'Cancel',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Cancel',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => handleOk(confirmLogOut),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default EirLogOutModal;
